import clsx from "clsx";
import { useCallback } from "react";
import { KTSVG } from "../../../_metronic/helpers";

type Props = {
  verdict: string | null
  value: string
  
  desc: string
  iconPath: string
  offClass: string
  onClass: string
  
  handleSelect: Function

  title?: string
  size?: number
}


export const VerdictButton = ({verdict, value, desc, title, iconPath, offClass, onClass, size, handleSelect} : Props) => {
  
  const onSelect = useCallback((e: any) => {
    e.stopPropagation();
    if (handleSelect) {
      handleSelect();
    }

  }, [handleSelect]);

  return (
  <div className={`col-${size ? size : 6} d-flex grow-1 align-self-stretch`} onClick={onSelect} title={title ? title : desc}>    
    <label
      className={clsx('btn py-2 px-4 d-flex flex-row align-items-center gx-2 align-self-stretch w-100',
        { [`${onClass}`] : (verdict === value)},
        { [`${offClass}`] : (verdict !== value)},
      )}      
    >
      <KTSVG path={iconPath} className='svg-icon-2x' />
      <div className='flex-grow-1 fw-bold text-center pe-2'>
        <span className='fw-bolder d-block fs-5 lh-1'>{desc}</span>                            
      </div>
      <input      
        type='radio'                        
        className='btn-check'
        name="verdict"
        value={value}
        onChange={onSelect}                                                            
      />
    </label>
  </div>        
  )
}